import React from 'react';
import { Zap } from 'lucide-react';

const FlashSaleButton = ({ onClick }) => (
  <button 
    onClick={onClick}
    className="w-full bg-amber-50 dark:bg-amber-900/50 border border-amber-200 dark:border-amber-700/50 rounded-lg p-4 flex items-center gap-3 text-left hover:bg-amber-100 dark:hover:bg-amber-900/70 transition-colors"
  >
    <div className="p-2 bg-amber-100 dark:bg-amber-800/50 rounded-full">
      <Zap className="w-6 h-6 text-amber-600 dark:text-amber-400" />
    </div>
    <div>
      <div className="font-medium text-gray-900 dark:text-white">Venta Relámpago</div>
      <div className="text-sm text-gray-500 dark:text-gray-400">Crear una venta sin lote existente</div>
    </div>
  </button>
);

export default FlashSaleButton; 